import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useEffect } from 'react';
import { MobileCenteredLayout } from '@/components/MobileCenteredLayout/MobileCenteredLayout';
import { OnboardingProgress } from '@/components/OnboardingProgress/OnboardingProgress';
import { trackSignupEvent } from '@/helpers/analytics';
import { SignupCta } from '@/Pages/Signup/components/SignupCta';
import { SignupForm } from '@/Pages/Signup/components/SignupForm';
import { SignupHeader } from '@/Pages/Signup/components/SignupHeader';
import { useSignupForm } from '@/Pages/Signup/hooks/useSignupForm';
import '@/Pages/Signup/SignupPage.sass';
import { WelcomeFooter } from '@/components/WelcomeFooter/WelcomeFooter';

export function SignupPage(): JSX.Element {
  const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const {
    form,
    fieldErrors,
    touched,
    isSubmitEnabled,
    isSubmitting,
    setField,
    blurField,
    submit,
  } = useSignupForm();

  useEffect(() => {
    void trackSignupEvent({ name: 'signup_page_view' });
  }, []);

  return (
    <MobileCenteredLayout>
      <Box
        component="main"
        className={
          prefersReducedMotion
            ? 'signup-page signup-page--reduced-motion'
            : 'signup-page'
        }
        data-testid="signup-page-main"
        data-motion={prefersReducedMotion ? 'reduced' : 'animated'}
      >
        <OnboardingProgress currentStep={4} />

        <SignupHeader />

        <SignupForm
          form={form}
          fieldErrors={fieldErrors}
          touched={touched}
          setField={setField}
          blurField={blurField}
        />

        <SignupCta
          disabled={!isSubmitEnabled}
          isSubmitting={isSubmitting}
          onSubmit={submit}
        />

        <WelcomeFooter/>
      </Box>
    </MobileCenteredLayout>
  );
}
